import script from "./marketing-email-items-configuration-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./marketing-email-items-configuration-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__